// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2JOda","label":"Labeled_label__1rVA7","divider":"Labeled_divider__1HOro"};